import { computed } from '@angular/core';


export function getLabels(isSpanish: boolean | undefined) {

	const en = computed(() => !isSpanish);

	return {

		missingRequired: computed(() => en() ? `Required field` : `Campo requerido`),
		optionalWithParentheses: computed(() => en() ? `(optional)` : `(opcional)`),
		select: computed(() => en() ? `Select` : `Seleccionar`),
		selected: computed(() => en() ? `selected` : `seleccionado`),
		selecteds: computed(() => en() ? `selected` : `seleccionados`),
		invalidSelection: computed(() => en() ? `Invalid Selection` : `Selección inválida`),
		notValidUrlPattern: computed(() => en() ? `Invalid URL (please include http:// or https://)` : `URL inválido (por favor incluya http:// o https://)`),
		notValidPhonePattern: computed(() => en() ? `Invalid phone number` : `Número de teléfono inválido.`),
		minPhoneLength: computed(() => en() ? `Phone must be at least 10 digits long.` : `El teléfono debe tener al menos 10 dígitos.`),
		maxPhoneLength: computed(() => en() ? `Phone must be shorter than 10 digits.` : `El teléfono debe ser más corto que 10 dígitos.`),
		notValidEmail: computed(() => en() ? `Invalid email address` : `Dirección de correo electrónico inválida`),
		notValidDate: computed(() => en() ? `Invalid date` : `Fecha inválida`),
		notValidAddress: computed(() => en() ? `Invalid address` : `Dirección inválida`),
		selectValidAddress: computed(() => en() ? `Select a valid Address` : `Seleccione una dirección válida`),
		invalidMailingAddress: computed(() => en() ? `Please enter a valid US mailing address` : `Ingrese una dirección postal válida de EEUU`),
		invalidCountyFipsId: computed(() => en() ? `Invalid Address field: Please update your address and try again` : `Campo de dirección no válido: actualice su dirección y vuelva a intentarlo`),
	};
}
